const InlineWorker = require('inline-worker');

class Recorder {
    config = {
        bufferLen: 4096,
        numChannels: 2,
        mimeType: 'audio/wav'
    };

    recording = false;

    callbacks = {
        getBuffer: [],
        exportWAV: []
    };

    constructor(source, cfg, callback) {
        Object.assign(this.config, cfg);
        this.context = source.context;
        this.node = (this.context.createScriptProcessor ||
            this.context.createJavaScriptNode).call(this.context,
                this.config.bufferLen, this.config.numChannels, this.config.numChannels);

        this.node.onaudioprocess = (e) => {
            if (!this.recording) return;
            // console.log('DEBUG::onaudioprocess',);

            var buffer = e.inputBuffer.getChannelData(0);

            this.worker.postMessage(buffer);
        };

        source.connect(this.node);

        this.node.connect(this.context.destination);    //this should not be necessary

        let self = {};
        this.worker = new InlineWorker(function () {
            this.onmessage = function (e) {
                record(e.data);
            };

            function record(inputBuffer) {
                // console.log('DEBUG::record',);
                const result = downsampleBuffer(inputBuffer, 44100, 16000);
                this.postMessage(result);
            }

            function downsampleBuffer(buffer, sampleRate, outSampleRate) {
                if (outSampleRate === sampleRate) {
                    return buffer;
                }
                if (outSampleRate > sampleRate) {
                    throw new Error('downsampling rate show be smaller than original sample rate');
                }
                var sampleRateRatio = sampleRate / outSampleRate;
                var newLength = Math.round(buffer.length / sampleRateRatio);
                var result = new Int16Array(newLength);
                var offsetResult = 0;
                var offsetBuffer = 0;
                while (offsetResult < result.length) {
                    var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
                    var accum = 0,
                        count = 0;
                    for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
                        accum += buffer[i];
                        count++;
                    }

                    result[offsetResult] = Math.min(1, accum / count) * 0x7fff;
                    offsetResult++;
                    offsetBuffer = nextOffsetBuffer;
                }
                return result.buffer;
            };

        }, self);

        this.worker.onmessage = (e) => {
            if (typeof callback == 'function') {
                callback(e.data);
            }
        };
    }

    record() {
        this.recording = true;
    }

    stop() {
        this.recording = false;
        this.node.disconnect(this.context.destination);
    }
}

class GSRecorder {
    loaded = true;

    #onDataAvailable;

    /**
     * Creates a Google Speech Recorder 
     * object
     * @param {function} onDataAvailable - Callback function to return speech data
     */
    constructor(onDataAvailable) {
        this.#onDataAvailable = onDataAvailable;
    }

    /**
     * Start recording audio
     * @param {MediaStream} stream - microphone input stream
     * @param {AudioContext} audioContext - Context for audio processing
     * @returns {boolean}
     */
    async start(stream, audioContext) {
        console.log("GSRecorder:loadRecorder");
        try {
            this.audioContext = audioContext;
            this.stream = stream;

            const input = this.audioContext.createMediaStreamSource(stream);

            this.recorder = new Recorder(input, { numChannels: 1 }, this.#onDataAvailable);

            console.log("GSRecorder:start");

            this.recorder?.record();
            console.log("GSRecorder::start Recording started");

            return true;
        } catch (err) {
            console.error(" GSRecorder:loadRecorder Error: ", err);
            return false;
        };

    }

    /**
     * Stop the recording
     * @returns {void}
     */
    end() {
        console.log("GSRecorder:stopRecording");
        //tell the recorder to stop the recording
        this.recorder?.stop();

        this.input = null;
        this.recorder = null;
    }
}

module.exports = GSRecorder;